import { $l } from '../locales';
import { SORT_ANSWERS_LIST, SORT_LIST } from '../constants/community';
import { ICommunityQuestion, ICommunityUser } from '../store/types/community';

export const reverseDirection = (oldDir: string) => (oldDir === 'asc' ? 'desc' : 'asc');

export const sortListWithNames = () =>
  SORT_LIST.map((el) => ({
    ...el,
    // @ts-ignore
    label: $l(el.label),
  }));

export const sortAnswersListWithNames = () =>
  SORT_ANSWERS_LIST.map((el) => ({
    ...el,
    // @ts-ignore
    label: $l(el.label),
  }));

export const communityUserInfo = (
  condition: boolean,
  user: ICommunityUser | Partial<ICommunityQuestion>,
) => ({
  infoText: condition
    ? 'AN'
    : `${user.firstName && user.firstName[0].toUpperCase()}${
        user.lastName && user.lastName[0].toUpperCase()
      }`,
  infoTitleText: condition ? $l('COMMUNITY.ANONYMOUS') : `${user.firstName} ${user.lastName}`,
});
